import {Link} from 'react-router-dom';
import styled from '@emotion/styled';
import {colors, fontSize, sizes} from 'patient-ping-remedy/packages/theme';
import {SmallTypography} from 'patient-ping-remedy/packages/typography';
import Badge from 'patient-ping-remedy/packages/badge';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 1.4rem;
  padding-block: ${sizes.small};
  padding-inline: ${sizes.small};

  &:not(:last-child) {
    border-bottom: 1px solid ${colors.gray2};
  }
`;

export const Main = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: ${sizes.xSmall};
  font-size: ${fontSize.standard};
  color: ${colors.charcoal};
  text-decoration: none;
  min-width: 0;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizes.xSmall};
`;

export const About = styled.span`
  color: ${colors.gray4};

  strong {
    color: ${colors.charcoal};
  }
`;

export const TimeSince = styled(SmallTypography)`
  display: flex;
  justify-content: end;
  flex-grow: 1;
  white-space: nowrap;
`;

export const Message = styled.div<{ unread?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${sizes.xSmall};
  white-space: nowrap;
  font-weight: ${({ unread }) => unread ? 'bold' : 'normal'};
`;

export const Content = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const Viewed = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const StyledBadge = styled(Badge)`
  border-radius: 2rem;
  white-space: nowrap;
`;
